import { createTheme } from "@mui/material";

export const PaginationTheme = createTheme({
    palette: {
      primary: {
        main: "#C3A0CD",
        darker: "#bc6277",
      },
    },
  });
  